import { render } from "./Xitong.vue?vue&type=template&id=0c5d7e61"
import script from "./Xitong.vue?vue&type=script&lang=js"
export * from "./Xitong.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__